import { CommodityType, SeverityType } from '@ui/aos-lib';
import { ListResponse, TableData } from '../../../shared/types/api-response.types';

export type Delivery = 'Immediate' | 'Scheduled';
export type Channel = 'Email' | 'Slack' | 'SMS' | 'Teams' | 'Telegram';

export interface SubscriptionManagement {
  readonly subscriptionId: number;
  readonly subscriptionName: string;
  readonly eventGroup: string | null;
  readonly eventName: string | null;
  readonly channel: Channel;
  readonly contact: string;
  readonly delivery: Delivery;
  readonly severityRules: SeverityType[];
  readonly commodity: CommodityType;
  readonly reportGroup: string | null;
  readonly duration: number | null;
}

export interface SubscriptionCreationAPIBody {
  name: string;
  isEnabled: boolean;
  eventGroup: string;
  eventName: string;
  severityRules: SeverityType[];
  contact: string;
  channel: Channel;
  delivery: Delivery;
  duration?: number;
}

export interface EditSubscriptionFormData {
  subscriptionName?: string;
  commodity?: string;
  reportGroup?: string | null;
  eventGroup?: string | null;
  eventName?: string | null;
  Notice?: boolean;
  Severe?: boolean;
  Warning?: boolean;
  Critical?: boolean;
  delivery?: string;
  channel?: string;
  contact?: string;
  duration?: number | null;
}

export type SubscriptionManagementTable = TableData<
  Omit<SubscriptionManagement, 'duration'> & { duration: number | ''; edit: string }
>;

export abstract class SubscriptionManagementPageContext {
  abstract editSubscriptionFormData: EditSubscriptionFormData | undefined;
  abstract subscriptionId: number;
  abstract openModal(): void;
}
export type SubscriptionManagementResponse = ListResponse<SubscriptionManagement>;
